var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensorBasedNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.673 41.813 c -0.194 0 -0.391 -0.028 -0.586 -0.088 c -1.056 -0.323 -1.65 -1.441 -1.328 -2.497 c 0.594 -1.941 0.895 -3.96 0.895 -6.001 c 0 -4.967 -1.804 -9.762 -5.078 -13.503 c -0.728 -0.831 -0.644 -2.095 0.188 -2.822 c 0.832 -0.728 2.095 -0.645 2.822 0.188 c 3.913 4.471 6.068 10.202 6.068 16.138 c 0 2.438 -0.359 4.85 -1.068 7.17 C 81.321 41.258 80.529 41.813 79.673 41.813 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 86.71 43.674 c -0.194 0 -0.391 -0.028 -0.586 -0.088 c -1.056 -0.323 -1.65 -1.441 -1.327 -2.498 c 0.773 -2.531 1.166 -5.165 1.166 -7.826 c 0 -6.478 -2.353 -12.732 -6.623 -17.61 c -0.728 -0.831 -0.644 -2.094 0.188 -2.822 c 0.829 -0.727 2.094 -0.645 2.822 0.188 c 4.909 5.607 7.613 12.797 7.613 20.245 c 0 3.058 -0.451 6.085 -1.341 8.996 C 88.358 43.12 87.565 43.674 86.71 43.674 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.252 41.813 c -0.857 0 -1.649 -0.555 -1.912 -1.417 c -0.709 -2.321 -1.068 -4.733 -1.068 -7.17 c 0 -5.937 2.155 -11.668 6.068 -16.138 c 0.728 -0.83 1.991 -0.915 2.822 -0.188 c 0.831 0.728 0.915 1.991 0.188 2.822 c -3.274 3.74 -5.078 8.536 -5.078 13.503 c 0 2.041 0.301 4.06 0.894 6.002 c 0.323 1.056 -0.272 2.174 -1.329 2.497 C 10.643 41.784 10.446 41.813 10.252 41.813 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.215 43.674 c -0.857 0 -1.649 -0.555 -1.912 -1.417 c -0.89 -2.912 -1.34 -5.938 -1.34 -8.995 c 0 -7.447 2.704 -14.637 7.613 -20.245 c 0.728 -0.831 1.992 -0.915 2.822 -0.188 c 0.831 0.728 0.915 1.991 0.188 2.822 c -4.271 4.878 -6.623 11.132 -6.623 17.61 c 0 2.661 0.392 5.294 1.166 7.827 c 0.323 1.056 -0.272 2.174 -1.329 2.497 C 3.605 43.646 3.408 43.674 3.215 43.674 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.501 80.902 C 35.723 85.962 39.885 90 45 90 s 9.277 -4.038 9.499 -9.098 C 48.166 78.328 41.834 78.328 35.501 80.902 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(67,74,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73.581 61.835 V 37.886 c 0 -15.784 -12.796 -28.58 -28.58 -28.58 l 0 0 c -15.784 0 -28.58 12.796 -28.58 28.58 v 23.949 c 0 3.033 -1.328 5.914 -3.634 7.884 l 0 0 c -2.307 1.97 -3.634 4.851 -3.634 7.884 l 0 0 c 0 1.822 1.477 3.299 3.299 3.299 h 65.099 c 1.822 0 3.299 -1.477 3.299 -3.299 l 0 0 c 0 -3.033 -1.328 -5.914 -3.634 -7.884 l 0 0 C 74.909 67.748 73.581 64.868 73.581 61.835 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 54.969 L 45 54.969 c -2.229 0 -4.05 -1.779 -4.101 -4.007 l -0.578 -24.875 c -0.053 -2.302 1.798 -4.198 4.101 -4.198 h 1.156 c 2.303 0 4.155 1.895 4.101 4.198 l -0.578 24.875 C 49.05 53.19 47.229 54.969 45 54.969 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 69.616 L 45 69.616 c -2.214 0 -4.008 -1.795 -4.008 -4.008 v -1.537 c 0 -2.214 1.795 -4.008 4.008 -4.008 h 0 c 2.214 0 4.008 1.795 4.008 4.008 v 1.537 C 49.008 67.822 47.214 69.616 45 69.616 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.5 13.091 c -1.117 0 -2.022 -0.906 -2.022 -2.022 V 8.522 C 36.478 3.823 40.301 0 45 0 c 4.7 0 8.522 3.823 8.522 8.522 v 2.545 c 0 1.117 -0.906 2.022 -2.022 2.022 c -1.117 0 -2.022 -0.906 -2.022 -2.022 V 8.522 c 0 -2.469 -2.009 -4.477 -4.477 -4.477 s -4.477 2.009 -4.477 4.477 v 2.546 C 40.523 12.186 39.617 13.091 38.5 13.091 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorBasedNotificationsIcon);
export default __webpack_public_path__ + "static/media/sensor_based_notifications_icon.e1d5131febc0206606b15549f1a30504.svg";
export { ForwardRef as ReactComponent };